import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDownRight } = FiIcons;

function Header() {
  return (
    <header className="site-header">
      <div className="header-inner page-width">
        <a href="/" aria-label="osmolaridade.com.br, início" className="brand logo"><svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><circle cx="12" cy="16" r="8" fill="none" stroke="currentColor" strokeWidth="3.5"/><circle cx="21" cy="16" r="5" fill="var(--logo-accent)"/></svg><span>Osmolaridade</span></a>
        <nav className="site-nav" aria-label="Navegação principal">
          <a href="#calculadora">Calculadora</a>
          <a href="#como-calcular">Como calcular</a>
          <a href="#perguntas-frequentes">Perguntas frequentes</a>
          <a className="nav-action" href="#conteudo">
            Explorar o guia <SafeIcon icon={FiArrowDownRight} aria-hidden="true" />
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
